import { ServiceAddressCard } from "@/services/backend/addresses/components/service-address-card";
import { useState } from "react";
import {
  UpdateCustomerAddressRequest,
  UpdateServiceAddressRequest,
  useVbsContractUpdateCustomerAddressMutation,
  useVbsContractUpdateServiceAddressMutation,
} from "@/services/backend/vbs/contracts/api/contract-api";
import { Contract } from "@/services/backend/vbs/contracts/types/contract";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { CustomerAddressCard } from "@/services/backend/addresses/components/customer-address-card";
import t from "@/lang/lang";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function ContractAddresses({ contract }: { contract: Contract }) {
  return (
    <div className="grid gap-2 lg:grid-cols-2">
      <CustomerAddress contract={contract} />
      <ServiceAddress contract={contract} />
    </div>
  );
}

function ServiceAddress({ contract }: { contract: Contract }) {
  const [request, setRequest] = useState<UpdateServiceAddressRequest>({
    id: contract.id,
    serviceAddress: contract.serviceAddress,
  });
  const mutation = useVbsContractUpdateServiceAddressMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: contract.id,
    serviceAddress: contract.serviceAddress,
  });

  return (
    <ServiceAddressCard
      address={request.serviceAddress}
      onAddressChange={(serviceAddress) =>
        setRequest({ ...request, serviceAddress })
      }
      disabled={isImmutable(contract)}
    />
  );
}

function CustomerAddress({ contract }: { contract: Contract }) {
  const [request, setRequest] = useState<UpdateCustomerAddressRequest>({
    id: contract.id,
    customerAddress: contract.customerAddress,
  });
  const mutation = useVbsContractUpdateCustomerAddressMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: contract.id,
    customerAddress: contract.customerAddress,
  });

  return (
    <CustomerAddressCard
      customerAddress={request.customerAddress}
      onCustomerAddressChange={(customerAddress) =>
        setRequest({ ...request, customerAddress })
      }
      fieldName="customerAddress"
      description={t(
        "Die Adresse des Unternehmens mit welchem der Vertrag geschlossen wird.",
      )}
      disabled={isImmutable(contract)}
    />
  );
}
